import apiV2 from '../../api/v2';

/**
 * Ref-1 "Review for refinement" GP decision — three mutually exclusive outcomes,
 * each backed by a V2 workflow-engine transition (the engine owns status changes).
 */

/** Approve → Ref-2 "Pending refinement records" (proceed to upload records). */
export async function approveRefinement(patientId: string): Promise<void> {
    await apiV2.post(`/patients/${encodeURIComponent(patientId)}/workflow/refinement/approve`, {});
}

/** Ref-2 → Ref-2.1: submit refinement records (begins clinical review). */
export async function submitRefinementRecords(
    patientId: string,
    refinementGoal: string
): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/refinement/upload-records`,
        { refinementGoal }
    );
}

/** Refuse & continue → Ref-0 "Doctor refused refinement" (treatment continues). */
export async function refuseRefinementContinue(patientId: string, reason: string): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/refinement/refuse-continue`,
        { reason }
    );
}

/** Refuse & end treatment → retention (Ret-2) or completion (Done), per retainer choice. */
export async function endTreatmentFromRefinement(
    patientId: string,
    retainerOption: string,
    reason: string
): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/refinement/end-treatment`,
        {
            retainerOption,
            reason
        }
    );
}

/** Ref-6.1 "Pending refinement approval" GP decision on the RDI design. */

/** Approve → proceeds the refinement case to manufacturing. Path is /rdi/*,
 *  not /design/* (that's Ref-5's separate clinical design review step). */
export async function approveRefinementDesign(patientId: string): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/refinement/rdi/approve`,
        {}
    );
}

/** Request revision → sends the RDI design back to the ortho team. */
export async function requestRefinementDesignRevision(
    patientId: string,
    note: string
): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/refinement/rdi/request-revision`,
        { note }
    );
}
